/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import styled from "styled-components";

import { Plate } from "src/classes/plate/Plate";
import { clientLogger } from "src/lib/logging/datadog";

export const EditorAvatars = ({ plate }: { plate: Plate }) => {
  clientLogger.log(`${plate}`);
  // const presentUsers = plate.socket.observe((state) => state.presentUsers);
  //@critical
  return (
    <AvatarsWrapper>
      {/* {presentUsers.map((collaborator) => (
        <EditorAvatar
          key={collaborator.username}
          username={collaborator.username}
          registeredWithUrbit={collaborator.registeredWithUrbit}
          avatarUrl={collaborator.avatarUrl || DEFAULT_AVATAR_URL}
        />
      ))} */}
    </AvatarsWrapper>
  );
};

const AvatarsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  user-select: none;
`;
